import { ValidationObserver, ValidationProvider } from 'vee-validate/dist/vee-validate.full.js';
//import { required } from 'vee-validate/dist/rules';
import Loader from '@/app/shared/layouts/components/loader/loader.vue';

import { loginService } from '@/app/shared/services/loginService.js';

localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en' ? import('./theme/login-form.scss') : import('./theme/login-form-rtl.scss');

//Module localization 
import localeEn from '../../../../locales/en'
import localeAr from '../../../../locales/ar'

export default {
    name: 'login-form',
    data() {
        return {
            formData: {
                userName: '',
                password: ''
            },
            isLoading: false,
            isDSLoaded: true,
            isPasswordShow: false,
            fieldType: 'password',
            iconMsg: 'Show',
            ShowErrorMsg: false,
            showLoginForm: false,
        }
    },
    methods: {
        httpGet(theUrl) {
            var xmlHttp = new XMLHttpRequest();
            xmlHttp.open("GET", theUrl, false); // false for synchronous request
            //??????????????
            xmlHttp.withCredentials = true;
            xmlHttp.send(null);
            var x = xmlHttp.response;
            return x;
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if (isValid) {
                this.isLoading = true;
                this.ShowErrorMsg = false;

                loginService.login(this.formData.userName, this.formData.password, (result) => {
                    console.log("***********loginSuccess********");
                    console.log(result);

                    if (result != null && result.data.ResponseStatus == 200 && result.data.token != null) {
                        result.data.token.NG_TRANSLATE_LANG_KEY = 'en';
                        loginService.saveTokenInfo(result.data.token);

                        //this.$router.push('/dashboard');
                      //  this.isLoading = true                        // rendering problem
                        
                        this.$nextTick(() => {
                            document.getElementById('routes').classList.remove('active')
                        })

                    }
                    else if (result.data.ResponseStatus == 404) {
                        this.ShowErrorMsg = true;
                        this.formData.userName = '';
                        this.formData.password = '';
                    }
                    else {
                        alert("somthing went wrong");
                        this.formData.userName = '';
                        this.formData.password = '';
                    }

                   // this.isLoading = false;
                }, (error) => {
                    console.log(error);
                    alert("somthing went wrong");
                    this.formData.userName = '';
                    this.formData.password = '';
                    this.isLoading = false;
                });
            }
            else {
                return
            }
        },
        showpassword() {
            this.isPasswordShow = !this.isPasswordShow;
            this.fieldType = (this.fieldType === 'password') ? 'text' : 'password';
            this.iconMsg = (this.iconMsg === 'Show') ? 'Hide' : 'Show';
        },
        trigger() {
            this.submit();
        }
    },
    mounted() {
        debugger
        window.addEventListener('message', (result) => {
            debugger
            if (result.data.tokenFromAngular) {
                localStorage.setItem("saveTokenFromAngular", true)
                loginService.saveTokenInfo(result.data.tokenFromAngular);
               // this.$router.push("/dashboard");
                this.$nextTick(() => {
                    document.getElementById('routes').classList.remove('active')
                    location.reload();
                })
            } else if (result.data.authenticationFlagFromAngular) {
                this.showLoginForm = true
            } else if (result.data.angularIsAuthenticated) {
                if (!localStorage.getItem("DisplayName")) {
                    document.getElementById('idMyIframe').contentWindow.postMessage({ ClearAllDataInAngular: true }, '*');//clear local storage and relogin
                }
            } else if (result.data.refreshApp) {
                location.reload();
            }
        });


    },
    //beforecreated() {
    //    loginService.login(null, null, (result) => {
    //        console.log("***********loginSuccess********");
    //        console.log(result);

    //        if (result != null && result.data.ResponseStatus == 200 && result.data.token != null) {
    //            loginService.saveTokenInfo(result.data.token);
    //            this.$router.push('/dashboard');
    //        }
    //    }, (error) => {
    //        console.log("***********loginFail********");
    //        console.log(error);
    //    });
    //},
    components: {
        ValidationProvider,
        ValidationObserver,
        Loader
    },
    directives: {
    },
    i18n: {
        messages: {
            en: {
                ...localeEn
            },
            ar: {
                ...localeAr
            }
        },
    },
};
